(ns web3.persistence.realtime
  (:require [web3.persistence.graphql :as g]
            [web3.queries.asset :as q-asset]))

;; Centriq has few "real-time" needs.
;; there is only one pressing use-case: after an asset
;; has been submitted, we want to know when it is finished
;; processing. So we will keep track of newly created assets,
;; and poll for updates.

(defn next-time
  "Backoff function.
  Call with 2 second delay 5 times, then back off to 10s, 30s, and random time b/w 60s and 3 minutes."
  [n]
  (if (< n 2050)
    (+ n 10)
    (case n
      2050 10000
      10000 30000
      (+ 60000 (* 120000 (js/Math.random))))))

(defn poll-asset-status!
  ([asset-id] (poll-asset-status! 2000 asset-id))
  ([timeout asset-id]
   (g/once q-asset/asset-alert-status
           {:id asset-id}
           {:on-complete
            (fn [^js payload]
              (let [processing? (some-> payload
                                        (.-data)
                                        (.-entity)
                                        (.-alertStatus)
                                        (= "processing"))]
                (when processing?
                  (js/setTimeout #(poll-asset-status! (next-time timeout) asset-id)
                                 timeout))))})))
